import EleicaoConselho from '../../views/public/eleicao_conselho'
import DetalheCandidato from '../../views/public/eleicao_conselho/DetalheCandidato'
import DetalheSecao from '../../views/public/eleicao_conselho/DetalheSecao'
import { DEFAULT_TITLE } from '../const'

export const eleicaoConselho = [
  {
    path: '/eleicao-conselho',
    name: 'eleicao_conselho',
    component: EleicaoConselho,
    meta: {
      title: `${DEFAULT_TITLE} | Eleição Conselho Tutelar`
    }
  },
  {
    path: '/eleicao-conselho/candidato',
    name: 'candidato_conselho',
    component: DetalheCandidato,
    meta: {
      title: `${DEFAULT_TITLE} | Eleição Por Candidato`
    }
  },
  {
    path: '/eleicao-conselho/secao/:secao',
    name: 'secao_conselho',
    component: DetalheSecao,
    meta: {
      title: `${DEFAULT_TITLE} | Eleição Por Seção`
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/public/eleicaoConselho.js